module.exports = __webpack_public_path__ + "static/media/dashboard.68080f05.jpg";